import { DatePipe } from '@angular/common';
import { Component, DestroyRef, HostListener, inject, OnDestroy, OnInit, signal, ViewEncapsulation, WritableSignal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { DocumentPreviewTypes, STATEMENT_VIEW_TYPES } from 'countable@helpers';
import { SPIN_STYLES, SpinInputModel, UserDetailModel } from 'countable@model';
import { FsExportService } from 'countable@services';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject, finalize, Subject, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { Column, ColumnValues, Row } from 'src/app/model/notes/notes-to-fs.model';
import { ApiService } from '../../../../../services/api.service';
import { idleTime } from '../../../../../services/app-config';
import { TimeTrackerService } from '../../../../../services/time-tracker.service';
import { WorkbookService } from '../../../../../services/workbook.service';

import { SharedService } from '../../../../shared/shared.service';

@Component({
	selector: 'notes-to-fs-preview',
	templateUrl: 'notes-to-financial-statements-preview.component.html',
	styleUrls: ['notes-to-financial-statements-preview.component.scss'],
	encapsulation: ViewEncapsulation.None,
	standalone: false
})

export class NotesToFinancialStatementsPreviewComponent implements OnInit, OnDestroy {

	userInactiveSub: Subscription;
	previewSub: Subscription;
	userInactive: Subject<any> = new Subject();

	trackobj: { engagementsId: any; submoduleId: any; submoduleUuid: any; };
	userActivity;
	engId: number;
	submoduleId: number;
	submoduleFsId: number;
	previewData = [];
	engName: string;
	clientFirmId: number;
	firmUserAcctId: number;
	userLoginId: number;
	headerNotesColumn1: string;
	headerNotesColumn2: string;
	headerNotesColumn3: string;
	headerSub: Subscription;
	clientName: any;
	currentYearFBS: any;
	htmlContent: string;
	isHideEditor: boolean;
	showDraftSub: Subscription;
	isShowDraft: boolean = false;
	isWorkBook: boolean;
	notesDataFromAPI: any;
	documentDefinition: object;
	pdfSrc: string = "";
	workBookSubModuleId: number;
	public placeOfPreview: STATEMENT_VIEW_TYPES = "None";

	public subscriptions: Subscription = new Subscription();
	public notes$: BehaviorSubject<any> = new BehaviorSubject<any>(null);
	public spinnerConfig: WritableSignal<SpinInputModel> = signal<SpinInputModel>(new SpinInputModel(null, SPIN_STYLES.BLUR_WITH_SPIN));
  private destroyRef = inject(DestroyRef);

	@HostListener('window:mousemove', ["$event"])
	@HostListener('window:resize', ["$event"])
	@HostListener('window:keydown', ["$event"])
	refreshUserState() {
		clearTimeout(this.userActivity);
		if (localStorage.getItem("timerStatus") == "Idle")
			this.trackerService.startTimer("Active");
		this.setTimeout();
	}

	@HostListener('window:storage', ['$event'])
	onStorageChange(ev: StorageEvent) {
		if ((ev.key === 'refreshNotes_to_FS') && (ev.newValue === 'refresh') && this.router.url == '/dashboard/ntrdashboard/FinancialStatement/doc/NotesToFinancialStatement') {
			this.updateSpinnerConfig(true);
			this.getPreviewNotes();
		}
	}

	constructor(private apiService: ApiService, private fsService: FsExportService, private router: Router,
		private toaster: ToastrService, private sharedService: SharedService,
		private trackerService: TimeTrackerService, private wbService: WorkbookService) {
		this.setTimeout();
		this.userInactive.subscribe(() => {
			this.trackerService.startTimer("Idle");
		});
		this.placeOfPreview = this.sharedService.setPlaceofPreview(this.router.url);
	}
	ngOnInit() {
    this.wbService.initChannel();
    this.wbService.message$
      .pipe(takeUntilDestroyed(this.destroyRef), debounceTime(200))
      .subscribe((data) => {
        data.id == this.submoduleFsId ? this.getPreviewNotes() : null;
      });

    this.sharedService.leftSideMenuNameChange.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(response => {
      if (response) {
        this.getPreviewNotes();
      }
    });
		const userDetail: UserDetailModel = JSON.parse(localStorage.getItem('userDetails'));
		if (userDetail) {
			this.firmUserAcctId = userDetail.firmUserAcctId;
			this.userLoginId = userDetail.useracctid;
		}
		this.engId = this.sharedService.getEngData("field", "selectedEngagementObjCopy", "engagementsid");
		this.engName = this.sharedService.getEngData("field", "selectedEngagementObjCopy", "engagementName");
		this.clientFirmId = this.sharedService.getEngData("field", "selectedEngagementObjCopy", "clientfirmid");
		this.clientName = this.sharedService.getEngData("field", "selectedEngagementObjCopy", "clientName");
		this.currentYearFBS = localStorage.getItem("endYear");
		this.submoduleFsId = JSON.parse(localStorage.getItem('FsSubmoduleId'));
		this.workBookSubModuleId = JSON.parse(localStorage.getItem('workBookSubmoduleId'));
		this.isWorkBook = localStorage.getItem('isWorkBook') == "true" ? true : false;

		this.trackobj = {
			"engagementsId": this.engId,
			"submoduleId": this.submoduleFsId,
			"submoduleUuid": localStorage.getItem("UUID"),
		}
		if (this.router.url == '/dashboard/ntrdashboard/FinancialStatement/doc/NotesToFinancialStatement') {
			localStorage.setItem("timeTrackerObj", JSON.stringify(this.trackobj));
			this.trackerService.startTimer("Active");
			this.submoduleId = this.submoduleFsId;
		}
		else {
			this.submoduleId = this.workBookSubModuleId;
		}
		this.getHeaderTitles('preview');
		var draft = JSON.parse((localStorage.getItem('showdraft')));
		if (draft) {
			this.isShowDraft = draft.isShowDraft ? draft.isShowDraft : '';
		}
		this.showDraftSub = this.sharedService.showdraft.subscribe(res => {
			if (res) {
				this.isShowDraft = res?.isShowDraft;
				this.getHeaderTitles('pdf');
			}
		});
		this.headerSub = this.sharedService.isFsNotesHeaderUpdate.subscribe(resp => {
			if (resp) {
				this.headerNotesColumn1 = resp[0].header[0].changednameline1;
				this.headerNotesColumn2 = resp[0].header[0].changednameline2;
				this.headerNotesColumn3 = resp[0].header[0].changednameline3;
			}
		})

		this.previewSub = this.sharedService.refreshNotesToFsPreview.subscribe(previewData => {
			if (previewData) {
				this.previewData = previewData;
				// this.createTableData();
				/* if(this.previewData){
					setTimeout(() => {
						var commentNodes = this.findComments(this.el.nativeElement);
						if (commentNodes && commentNodes.length) {
							commentNodes.forEach(element => {
								if (element.data == ' my page break ') {
									var span = document.createElement("span");
									span.innerText = " ";
									span.style.height = "0 !important";
									span.style.display = "none!important";
									span.classList.add('pdf-pagebreak-before');
									//element.nextElementSibling.firstChild.classList.add("pdf-pagebreak-before")
									element.parentNode.replaceChild(span, element);
								}
							});
						}
					}, 1000);
					this.generatePDF();
				} */
			}
		})

		var draft = JSON.parse((localStorage.getItem('showdraft')));
		if (draft) {
			this.isShowDraft = draft.isShowDraft ? draft.isShowDraft : '';
		}
		this.showDraftSub = this.sharedService.showdraft.subscribe(res => {
			if (res) {
				this.isShowDraft = res?.isShowDraft;
				this.updateSpinnerConfig(true);
				this.getPreviewNotes();
			}
		});
		// this.getPreviewNotes(); Calling as a part of this.getHeaderTitles('preview'); line no 125
		this.updateWorkBook();
		this.subscriptions.add(
			this.notes$.pipe().subscribe({
				next: notesData => {
					this.notesDataFromAPI = localStorage.getItem('NotesExists')
					if (notesData && document.getElementById("notes-preview")) {
						document.getElementById("notes-preview").innerHTML = notesData;
						// console.log("preview data html",notesData)
						// Setting watermark
						const waterMark = this.sharedService.showdraft.value;
						const waterMarkUrl = this.sharedService.waterMarkUrl.getValue();
						if ((waterMark && waterMark.isShowDraft) && waterMarkUrl) {
							document.getElementById("notes-preview").style.backgroundImage = `url(${waterMarkUrl})`;
						} else {
							document.getElementById("notes-preview").style.backgroundImage = "none";
						}
            this.updateSpinnerConfig(false);
					}
				}
			})
		);
	}

	setTimeout() {
		this.userActivity = setTimeout(() => this.userInactive.next(undefined), idleTime);
	}

	getHeaderTitles(apiCall?) {
		let engId = this.engId;
		let subModuleId = this.submoduleId;

		this.wbService.getWbHeaderNote(engId, subModuleId).subscribe({
			next: res => {
				if (res?.status === 200 && res?.data) {
					let results = JSON.parse(res?.data);
					this.headerNotesColumn1 = results[0].header[0].changednameline1;
					this.headerNotesColumn2 = results[0].header[0].changednameline2;
					this.headerNotesColumn3 = results[0].header[0].changednameline3;
					if (apiCall == 'preview') {
						this.updateSpinnerConfig(true);
						this.getPreviewNotes();
					}
				}
			}, error: e => {
				this.toaster.error(e.error);
			}
		});
	}

	getPreviewNotes() {
		this.subscriptions.add(
			this.fsService.fetchFSDocPreview(DocumentPreviewTypes.NOTES).pipe(finalize(() => this.updateSpinnerConfig(false))).subscribe({
				next: res => {
					if (res) {
						this.notes$.next(res);
					}
				}
			})
		);
	}

	updateWorkBook() {
		this.subscriptions.add(
			this.sharedService.updateWorkBookPreview.subscribe((resp) => {
				if (resp) {
					this.notesDataFromAPI = localStorage.getItem('NotesExists');
				}
			})
		);
	}

	trackByNotes(index, item) {
		return index;
	}

	createTableData() {
		this.previewData.forEach(note => {
			if (note.content && note.content.length) {
				note.content.forEach(section => {
					if (section.type === 'table') {
						if (section.rows && section.rows.length) {
							const totaRowIndex = section.rows.findIndex(val => val.rowId === 'totalrow');
							if (totaRowIndex === -1) {
								section.rows.push(this.createRowObject('totalrow', 'Total', false, []));
							}
						}
						section['viewModeDispCol'] = (section.columns && section.columns.length) ? ['description', ...section.columns.map(col => col.colId)] : [];
						section['viewModeRowsData'] = (section.rows && section.rows.length) ? section.rows : [];
						if (section.columns.length) {
							const engagementYearEnd = localStorage.getItem("endYear");
							const currIndex = section.columns.findIndex(ele => ele.colId === 'currYear');
							const prevIndex = section.columns.findIndex(ele => ele.colId === 'priorYear');
							if (currIndex > -1) {
								section.columns[currIndex].name = this.getFormattedDate(engagementYearEnd);
							}
							if (prevIndex > -1) {
								section.columns[prevIndex].name = this.getFormattedDate(engagementYearEnd, true);
							}
						}
					}
				})
			}
		});
		// console.log("preview data",this.previewData)
	}

	createRowObject(rowId: string, name: string, isHide: boolean, columns: Column[]): Row {
		const colvalues: ColumnValues[] = [];

		columns.forEach(val => {
			const obj: ColumnValues = {
				colId: val.colId,
				colValue: 0
			}
			colvalues.push(obj);
		})

		const row: Row = {
			rowId,
			name,
			isHide,
			values: JSON.parse(JSON.stringify(colvalues))
		}
		return row;
	}

	getFormattedDate(date: string, minusOneYear?: boolean) {
		const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
		const dateObj = new Date(date);
		if (!minusOneYear) {
			return `${months[dateObj.getMonth()]} ${dateObj.getDate()}, ${dateObj.getFullYear()}`;
		} else {
			dateObj.setDate(dateObj.getDate() + 1);
			if (months[dateObj.getMonth()] === 'January' && dateObj.getDate() === 1) {
				return `December 31, ${dateObj.getFullYear() - 2}`;
			}
			return `${months[dateObj.getMonth()]} ${dateObj.getDate()}, ${dateObj.getFullYear() - 1}`;
		}
	}

	getColValue(columnValues: ColumnValues[], colId: string): number {
		const index = columnValues.findIndex(col => col.colId === colId);
		return (index > -1) ? columnValues[index].colValue : 0;
	}

	getTotalColValue(rows: any, colId: string): number {
		let cols: ColumnValues[] = []
		rows.forEach(row => {
			if (row.values.length && !row.isHide) {
				cols.push(row.values.filter(val => val.colId === colId)[0]);
			}
		});
		const values = cols.map(col => {
			return (col && col.colValue && typeof col.colValue === 'number') ? col.colValue : 0;
		});
		return values.reduce((a, b) => a + b, 0);
	}

	getRowTotalValue(columnValues: ColumnValues[]): number {
		const values = columnValues.map(col => {
			return (col && col.colValue && typeof col.colValue === 'number') ? col.colValue : 0;
		});
		return values.reduce((a, b) => a + b, 0);
	}

	getGrandTotalValue(rows: any) {
		const values: number[] = [];
		rows.forEach(row => {
			if (row.values.length && !row.isHide) {
				row.values.forEach(col => {
					const val = (col && col.colValue && typeof col.colValue === 'number') ? col.colValue : 0;
					values.push(val);
				})
			}
		});
		return values.reduce((a, b) => a + b, 0);
	}

	showFormattedNumber(data: number | string) {
		if (typeof data === 'number') {
			if (data > 0) {
				return data.toLocaleString('en-us');
			} else if (data < 0) {
				const absoluteNumber = data * -1;
				const formatted = absoluteNumber.toLocaleString('en-US');
				return '(' + formatted + ')';
			} else {
				return '-';
			}
		} else {
			return data;
		}
	}

	ngOnDestroy() {
		if (this.router.url == '/dashboard/ntrdashboard/FinancialStatement/doc/NotesToFinancialStatement') {
			clearTimeout(this.userActivity);
		}
		this.previewSub ? this.previewSub.unsubscribe() : '';
		this.headerSub ? this.headerSub.unsubscribe() : '';
		this.showDraftSub ? this.showDraftSub.unsubscribe() : '';
		this.subscriptions && this.subscriptions.unsubscribe();
		this.fsService.removeFsDocPreviewPage(DocumentPreviewTypes.NOTES);
    this.wbService.closeChannel();
	}

	private updateSpinnerConfig(value: boolean) {
		this.spinnerConfig.update((config) => ({ ...config, isSpinShown: value }));
	}
}
